import { motion } from "framer-motion";
import { Mail, MapPin, ArrowUpRight } from "lucide-react";
import { RevealLine, Rise, SectionLabel } from "./Motion";

export default function Contact() {
  return (
    <section
      id="contact"
      className="relative overflow-hidden bg-vg-primary py-24 lg:py-36"
      data-testid="contact-section"
    >
      <div className="grain absolute inset-0 opacity-[0.06]" />
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10">
        <SectionLabel dark>05 — Get in touch</SectionLabel>

        <h2 className="mt-8 max-w-4xl font-display text-4xl font-semibold leading-[1.02] tracking-tight text-white sm:text-6xl lg:text-7xl">
          <RevealLine>Let&apos;s build</RevealLine>
          <RevealLine delay={0.08}>
            what&apos;s <span className="text-vg-accent">next.</span>
          </RevealLine>
        </h2>

        <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden rounded-sm border border-white/15 bg-white/10 lg:grid-cols-2">
          <a
            href="mailto:INFO@VENUSRENEWABLES.COM"
            data-testid="contact-email-link"
            className="group flex flex-col justify-between gap-8 bg-vg-primary p-10 transition-colors duration-500 hover:bg-[#053723] lg:p-14"
          >
            <div className="flex items-center justify-between">
              <Mail className="text-vg-accent" size={32} />
              <ArrowUpRight
                className="text-white/60 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                size={24}
              />
            </div>
            <div>
              <div className="text-xs font-medium uppercase tracking-[0.2em] text-vg-accent">
                Email us
              </div>
              <div className="mt-3 break-all font-display text-xl font-medium text-white lg:text-2xl">
                INFO@VENUSRENEWABLES.COM
              </div>
            </div>
          </a>

          <div
            data-testid="contact-address"
            className="flex flex-col justify-between gap-8 bg-vg-primary p-10 lg:p-14"
          >
            <MapPin className="text-vg-accent" size={32} />
            <div>
              <div className="text-xs font-medium uppercase tracking-[0.2em] text-vg-accent">
                Registered office
              </div>
              <address className="mt-3 not-italic font-display text-xl font-medium leading-snug text-white lg:text-2xl">
                2nd to 4th Floor, Plot A, Opp. Chandra Prabhu Digamber Jain
                Temple, Parle Point, Surat, Gujarat 395007
              </address>
            </div>
          </div>
        </div>

        <Rise delay={0.1} className="mt-10 text-sm text-white/55">
          Venus Green Renewables &amp; Energy Pvt. Ltd. — turnkey EPC solutions
          across India.
        </Rise>
      </div>
    </section>
  );
}
